var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.752,
    height: 13.431,
    viewBox: "0 0 11.752 13.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shopping-bag",
    "data-name": "Icon awesome-shopping-bag",
    d: "M9.234,4.2V3.358a3.358,3.358,0,0,0-6.716,0V4.2H0v7.135a2.1,2.1,0,0,0,2.1,2.1H9.654a2.1,2.1,0,0,0,2.1-2.1V4.2ZM4.2,3.358a1.679,1.679,0,1,1,3.358,0V4.2H4.2Zm4.2,3.148a.63.63,0,1,1,.63-.63A.63.63,0,0,1,8.395,6.506Zm-5.037,0a.63.63,0,1,1,.63-.63A.63.63,0,0,1,3.358,6.506Z",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.3737d477f2be651127b7ac75ce719357.svg";
export { ForwardRef as ReactComponent };